export default "__VITE_ASSET__BSChPU5G__"